import { ServiceBase } from "./ServiceBase";

export class CadastroService extends ServiceBase {
    
    async getAll(url: string) {
        return this.get(url);
    }

    async postItem(body: any) {
        let url = '/api/Cadastros/Adicionar';
        return this.post(url, body);
    }

    async postDeleteItem(body: any) {
        let url = '/api/Cadastros/Deletar';
        return this.post(url, body);
    }

}